import type { Route } from '@angular/router';
import {
  sequentialDeactivateGuards,
  hasStringPathParamCanActivateGuard,
} from '@pct-ng/core/router';
import { showToasterDeactivateGuard } from '@pct-ng/form';
import { dirtyCheckCanDeactivateGuard } from '@pct-ng/feature-dirty-check';

export const locationCategoryRoutes: Route[] = [
  {
    path: '',
    loadComponent: () =>
      import('./list/location-category-list.component').then(
        ({ LocationCategoryListComponent }) => LocationCategoryListComponent,
      ),
    pathMatch: 'full',
  },
  {
    path: 'new',
    loadComponent: () =>
      import('./details/location-category-details.component').then(
        ({ LocationCategoryDetailsComponent }) => LocationCategoryDetailsComponent,
      ),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.NEW',
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.LOCATION.CATEGORY.SINGULAR'),
      ]),
    ],
  },
  {
    path: ':id',
    loadComponent: () =>
      import('./details/location-category-details.component').then(
        ({ LocationCategoryDetailsComponent }) => LocationCategoryDetailsComponent,
      ),
    title: 'PAGES.LOCATION.CATEGORY.BREADCRUMB.EDIT',
    canActivate: [hasStringPathParamCanActivateGuard('id')],
    canDeactivate: [
      sequentialDeactivateGuards([
        dirtyCheckCanDeactivateGuard(),
        showToasterDeactivateGuard('PAGES.LOCATION.CATEGORY.SINGULAR'),
      ]),
    ],
  },
];
